export default {"src":"/_next/static/media/DevsnestLogo.ddc39e19.svg","height":515,"width":451,"blurWidth":0,"blurHeight":0};